import React, { lazy } from 'react';

const ProcessLogin = lazy(() => import('./views/integration/ProcessLogin'));
const Login = lazy(() => import('./views/Login'));
const ForgotPassword = lazy(() => import('./views/ForgotPassword'));
const ResetPassword = lazy(() => import('./views/ResetPassword'));
const ThankyouMessage = lazy(() => import('./views/ThankyouMessage'));
const ConfirmationEmailForm = lazy(() => import('./views/ConfirmationEmailForm'));
const Home = lazy(() => import('./views/Home'));
const TrayView = lazy(() => import('./views/workflow/tray'));
const WorkflowNewEntity = lazy(() => import('./views/workflow/new'));
const WorkflowEntityDetails = lazy(() => import('./views/workflow/details'));
const WorkflowViewEntity = lazy(() => import('./views/workflow/view'));
const WorkflowEntityLog = lazy(() => import('./views/workflow/log'));
const AnonymousAccessView = lazy(() => import('./views/anonymous/AnonymousAccessView'));
const IntegrationUser = lazy(() => import('./views/users/IntegrationUser'));
const IntegrationUserTest = lazy(() => import('./views/users/test/IntegrationUserTest'));
const Profile = lazy(() => import('./views/Profile'));
const FirstLogin = lazy(() => import('./views/FirstLogin'));
const Faq = lazy(() => import('./views/Faq'));
const SystemSettings = lazy(() => import('./views/SystemSettings'));
const Help = lazy(() => import('./views/Help'));
const TicketPage = lazy(() => import('./views/TicketPage'));
const CreateItem = lazy(() => import('./views/SystemSettings/Invoce/CreateItem'));
const EditItem = lazy(() => import('./views/SystemSettings/Invoce/EditItem'));
const ListInvoiceItem = lazy(() => import('./views/SystemSettings/Invoce/ListInvoiceItem'));
const RedirectToPage = lazy(() => import('./views/redirect/RedirectToPage'));
import DashboardView from './views/DashboardView';


const routes = {
  '/process-login': { component: ProcessLogin, excludeFromProfileCheck: true },
  '/login': { component: Login, default: 1, excludeFromProfileCheck: true },
  '/forgot-password': { component: ForgotPassword, excludeFromProfileCheck: true },
  '/reset-password/:token': { component: ResetPassword, excludeFromProfileCheck: true },
  '/register': { component: ResetPassword, excludeFromProfileCheck: true },

  '/thankyou': { exact: true, component: ThankyouMessage, excludeFromProfileCheck: true },
  '/confirmationEmailForm/:token': { exact: true, component: ConfirmationEmailForm, excludeFromProfileCheck: true },

  '/': { exact: true, component: Home, default: 10 },

  '/workflow/:slug/tray': { exact: true, component: TrayView, requires: 'login' },
  '/workflow/:entityType/new': { exact: true, component: WorkflowNewEntity, requires: 'login' },
  '/workflow/:entityType/:id': { exact: true, component: WorkflowEntityDetails, requires: 'login' },
  '/workflow/:entityType/:id/view': { exact: true, component: WorkflowViewEntity, requires: 'login' },
  '/workflow/:entityType/:id/log': { exact: true, component: WorkflowEntityLog, requires: 'permissions.ManageWorkflow' },

  '/anonymous/:tenant/': { component: AnonymousAccessView, excludeFromProfileCheck: true },

  '/integration/user/:jediid/settings': { component: IntegrationUser, exact: true, excludeFromProfileCheck: true },
  '/test/integration/users/iframe': { component: IntegrationUserTest, exact: true },

  '/profile': { component: Profile, exact: true, requires: 'login', excludeFromProfileCheck: true },
  '/firstLogin': { component: FirstLogin, exact: true, requires: 'login', excludeFromProfileCheck: true },

  '/faq': { component: Faq, exact: true, requires: 'login', excludeFromProfileCheck: true },

  '/system-settings': { component: SystemSettings, exact: true, requires: 'login' },
  '/system-settings/:setting': { component: SystemSettings, requires: 'login' },

  '/support': { component: Help, requires: 'login' },

  '/create-ticket': { component: TicketPage, requires: 'login' },

  '/invoice/create': { component: CreateItem, exact: true, requires: 'login' },
  '/invoice/:id': { component: EditItem, exact: true, requires: 'login' },
  '/invoice': { component: ListInvoiceItem, exact: true, requires: 'login' },
  '/redirect/:endpoint': { component:  RedirectToPage, exact: true, requires: 'login' },
  '/dashboard/:dashboardUuid': { component: DashboardView, exact: true, requires: 'login', excludeFromProfileCheck: true },
};

export default routes;